import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddVideoToRemoveBucketInterface {
  id: string;
  vid: string[];
}

export const useAddVideoToRemoveBucket = () => {
  const mutate = useMutation(({ id, vid }: AddVideoToRemoveBucketInterface) => {
    return postAPI('/external-api/add_VideoTo_RemoveBucket', {
      enterprise_id: id,
      video_ids: vid,
    });
  });

  return mutate;
};

export default useAddVideoToRemoveBucket;
